import { createSelector } from 'reselect';

const selectendpoints = (state: any) => state.endpoints;


export const selectendpointsCurrentItem = createSelector([selectendpoints], (endpoints) => endpoints.current);

export const selectendpointsListItems = createSelector([selectendpoints], (endpoints) => endpoints.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectendpointsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectendpointsQueryItems = createSelector([selectendpoints], (endpoints) => endpoints.query);

export const selectendpointsCreatedItem = createSelector([selectendpoints], (endpoints) => endpoints.create);

export const selectendpointsUpdatedItem = createSelector([selectendpoints], (endpoints) => endpoints.update);

export const selectendpointsReadItem = createSelector([selectendpoints], (endpoints) => endpoints.read);

export const selectendpointsDeletedItem = createSelector([selectendpoints], (endpoints) => endpoints.delete);

export const selectendpointsSearchedItems = createSelector([selectendpoints], (endpoints) => endpoints.search);

export const selectendpointsItemsCount = createSelector([selectendpoints], (endpoints) => endpoints.count);

export const selectendpointsItemsFilter = createSelector([selectendpoints], (endpoints) => endpoints.filter);